export default {

  //----- CLICK UP ------------------------------------------------------------------

  CLICKUP: {
    API_TOKEN: "pk_4696131_B80O8V8PSSBJ6OYZNE28YU16Q1277R73",
    API_TOKEN_MAIN: "pk_68620743_1WVPRM89L586WKU5SGG3IJGFO36TN6N1",
    SPACES: {
      MGD: "90151934858",
    },
    FOLDERS: {
      MANUFACTURE: "90154478391",
    },
    LISTS: {
      MANUFACTURING_ORDERS: "901507206279",
      POLISHING_ORDERS: "",
      ASSEMBLING_ORDERS: "",
      MOVEMENT_ORDERS: "",
      PURCHASING_ORDERS: "901507206250",
    },
    TEAM: "9015575337",
    USERS: {
      MAIN: "9015575337",
      DUKE: "68620743",
      MANON: "68624965",
      ALESSIO: "68624920",
      BEKIM: "",
      SEBASTIEN: "",
      JULIEN: "",
      JEAN_LOUIS: "",
      MISHA: "4696131",
    },
    FIELDS: {
      QUANTITY: "04ff9163-ed7b-40b7-870b-3ce9f3f62b07",
      QUANTITY_WASTE: "13d34d34-1a05-4b53-bdd0-e9bccb0ff666",
      ORDER_TYPE: "2e3e630e-a435-46b7-ad26-9f05ee32187f",
      PRICE_UNIT: "33c426ca-1a62-478b-90ca-85610b85888f",
      PRICE_TOTAL: "9d601d6b-7b93-4097-a87b-407a55e20eee",
    },
  },

  //----- WEBHOOK PAYLOAD ------------------------------------------------------------------

  PAYLOAD: {
    event: "taskStatusUpdated",
    history_items: [
      {
        id: "4293033558178321323",
        type: 1,
        date: "1731680879825",
        field: "status",
        parent_id: "901507206250",
        data: { status_type: "custom" },
        source: null,
        user: {
          id: 4696131,
          username: "Misha",
          email: "mbourg@jymbe.com",
          color: "",
          initials: "M",
          profilePicture: "https://attachments.clickup.com/profilePictures/4696131_vHi.jpg",
        },
        before: { status: "in delivery", color: "#1090e0", orderindex: 3, type: "custom" },
        after: { status: "order placed", color: "#e16b16", orderindex: 2, type: "custom" },
      },
    ],
    task_id: "86c10zx35",
    webhook_id: "de671821-d1b5-4e3c-84c8-d367f3436bc5",
  },

  PAYLOAD2: {
    event: "taskUpdated",
    history_items: [
      {
        id: "4293033558178321323",
        type: 1,
        date: "1731680879825",
        field: "status",
        parent_id: "901507206250",
        data: { status_type: "custom" },
        source: null,
        user: {
          id: 4696131,
          username: "Misha",
          email: "mbourg@jymbe.com",
          color: "",
          initials: "M",
          profilePicture: "https://attachments.clickup.com/profilePictures/4696131_vHi.jpg",
        },
        before: { status: "in delivery", color: "#1090e0", orderindex: 3, type: "custom" },
        after: { status: "order placed", color: "#e16b16", orderindex: 2, type: "custom" },
      },
    ],
    task_id: "86c10zx35",
    webhook_id: "de671821-d1b5-4e3c-84c8-d367f3436bc5",
  },
}